var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 450,
    viewBox: "0 0 554 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1607_4998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20996 124.38L276.74 7.12012V205.3L8.20996 322.57V124.38Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.27 124.38L553.99 120.88V327.37L545.27 331.82V124.38Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74 439.83L545.27 322.57V331.82L276.74 449.08V439.83Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.55 281.29L160.79 253.34L158.13 220.45L91.77 249.6L102.55 281.29Z",
    fill: "#6084C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74 205.3L8.20996 322.57L276.74 439.83L545.27 322.57L276.74 205.3Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25 0L268.53 3.69L545.27 124.38L553.99 120.69L277.25 0Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53 3.68994L0 120.95L8.21 124.38L276.74 7.11994L268.53 3.68994Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.27 124.38L276.74 7.12012V205.3L545.27 322.57V124.38Z",
    fill: "#305D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21 124.38L0 120.95V328.39L8.21 331.82V124.38Z",
    fill: "#305D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74 439.83L8.20996 322.57V331.82L276.74 449.08V439.83Z",
    fill: "#305D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74 7.12012L227.9 226.63L276.74 205.3V7.12012Z",
    fill: "#6084C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.9 226.63L492.05 345.81L545.27 322.57L276.74 205.3L227.9 226.63Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77 88.6301L292.68 66.3201V163.32L344.21 185.82L343.77 88.6301Z",
    fill: "#4780D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.22 114.47L353.12 92.1602V189.16L404.66 211.66L404.22 114.47Z",
    fill: "#4780D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 140.34L413.71 118.03V215.02L465.24 237.53L464.8 140.34Z",
    fill: "#4780D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.25 166.18L474.16 143.87V240.87L525.69 263.37L525.25 166.18Z",
    fill: "#4780D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.68 163.32L299.01 159.73L344.19 179.74L344.21 185.82L292.68 163.32Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.01 159.73V69.0801L292.68 66.3201V163.32L299.01 159.73Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.12 189.16L359.45 185.57L404.64 205.58L404.66 211.66L353.12 189.16Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.45 185.57V94.9202L353.12 92.1602V189.16L359.45 185.57Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71 215.02L420.04 211.44L465.22 231.44L465.24 237.53L413.71 215.02Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.04 211.44V120.79L413.71 118.03V215.02L420.04 211.44Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.16 240.87L480.48 237.28L525.67 257.28L525.69 263.37L474.16 240.87Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.48 237.28V146.63L474.16 143.87V240.87L480.48 237.28Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.53 325.21L19.3101 317.72L53.6701 301.96L106.53 325.21Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3101 317.72L53.7401 225.67L53.6701 301.96L19.3101 317.72Z",
    fill: "#6084C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9798 167.96L53.6598 183.79C52.0198 184.4 51.0798 186.12 51.4498 187.83L59.1598 223.84C59.6198 225.97 61.8698 227.18 63.8898 226.38L115.82 205.96C117.4 205.34 118.31 203.68 117.99 202.02L111.15 166.25C110.73 164.06 108.4 162.8 106.34 163.66L95.9798 167.96Z",
    fill: "#6084C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.09 281.29L108.38 278.82L152.95 259.36L206.09 281.29Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 391.19L162.89 390.45L105.31 364.97L206.74 326.9L306.03 324L350.5 341.37L262.6 346.78L259.2 391.19Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 347.55C178.82 343.53 175.35 337.05 173.32 333.24C172.4 331.52 170.3 330.81 168.52 331.63L117.54 355.11C115.19 356.19 114.66 359.29 116.51 361.1L128.84 373.13C129.93 374.19 131.56 374.48 132.94 373.85L179.41 352.72C181.38 351.82 182.16 349.43 181.1 347.55Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.94 306.64C180.88 310.55 194.24 312.43 184.41 316.96C174.58 321.49 158.63 321.6 152.69 325.13C146.75 328.66 145.21 335.95 132.62 333.96C120.03 331.97 112.19 328.77 110.87 326.34C109.55 323.91 106.99 315.72 107.16 311.81C107.33 307.9 106.68 297.09 106.68 297.09C106.68 297.09 109.55 291.21 115.4 290.94C121.25 290.67 133.23 291.17 137.18 292.52C141.13 293.87 150.19 294.36 153.61 296.05C157.03 297.74 162.67 298.18 164.32 298.18C165.97 298.18 170.28 297.33 171.99 300.18C173.7 303.03 175.95 306.63 175.95 306.63L175.94 306.64Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63 381.73C344.13 385.64 359 387.52 348.06 392.05C337.12 396.58 319.36 396.69 312.74 400.22C306.12 403.75 304.41 411.04 290.39 409.05C276.37 407.06 267.64 403.86 266.17 401.43C264.7 399 261.85 390.81 262.04 386.9C262.23 382.99 261.5 372.18 261.5 372.18C261.5 372.18 264.69 366.3 271.21 366.03C277.73 365.76 291.06 366.26 295.46 367.61C299.86 368.96 309.94 369.45 313.75 371.14C317.56 372.83 323.83 373.27 325.68 373.27C327.53 373.27 332.31 372.42 334.22 375.27C336.13 378.12 338.62 381.72 338.62 381.72L338.63 381.73Z",
    fill: "#94BDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 248.82L53.6699 225.67V302.3L106.67 325.44V248.82Z",
    fill: "#B57D2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35 205.28L153.35 182.13V258.76L206.35 281.9V205.28Z",
    fill: "#B57D2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73 180.23L53.6699 225.67L106.6 248.73L210.66 203.29L157.73 180.23Z",
    fill: "#FCCF97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 248.7L110.98 246.83V323.57L106.67 325.44V248.7Z",
    fill: "#D8A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35 205.16L210.66 203.29V280.03L206.35 281.9V205.16Z",
    fill: "#D8A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 248.7L210.66 203.29V209.38L106.67 255.27V248.7Z",
    fill: "#D8A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.07 198.18L89.9897 212.19L106.31 219.3L138.39 205.29L122.07 198.18Z",
    fill: "#BFC9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12 209.29L91.5197 212.86L89.9897 212.19L107.9 204.37L115.12 209.29Z",
    fill: "#A3B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9 191.02H118.06V205.78C118.06 207.75 116.46 209.35 114.49 209.35H111.48C109.51 209.35 107.91 207.75 107.91 205.78V191.02H107.9Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2998 161.59L135.81 135.17C137.82 134.29 140.12 135.59 140.41 137.76L146.02 180.25C146.21 181.71 145.42 183.12 144.07 183.71L83.5598 210.13C81.5498 211.01 79.2498 209.71 78.9598 207.54L73.3498 165.05C73.1598 163.59 73.9498 162.18 75.2998 161.59Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1597 165.29L137.69 138.87L143.12 180L82.5997 206.43L77.1597 165.29Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23 207.58L110.5 222.74L128.16 230.44L162.89 215.28L145.23 207.58Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 222.74V224.37L128.17 232.02V230.44L110.5 222.74Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.17 232.02L162.89 216.92V215.28L128.17 230.44V232.02Z",
    fill: "#BFC9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35 194.16L155.28 204.27L172.1 211.59L195.17 201.48L178.35 194.16Z",
    fill: "#DAE4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.13 201.79C168.13 201.79 172.26 205.17 174.32 206.45C176.38 207.73 180.82 207.28 181.48 205.18C182.14 203.08 179.24 200 176.52 199.43C173.8 198.86 170.81 199.21 170.81 199.21L168.13 200.48V201.8V201.79Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32 206.44C175.32 207.06 176.87 207.27 178.29 207.09C176.58 207 175.87 205.03 175.54 203.72C175.21 202.41 172.75 201.16 171.68 201.04C170.61 200.92 168.6 200.54 168.12 200.46V201.78C168.12 201.78 172.25 205.16 174.31 206.44H174.32Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 225.67L119.34 240.57L98.82 247.94L87.73 231.24L104.9 225.67Z",
    fill: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7998 232.02L103.29 246.07L116.1 236.61L94.5598 225.67L80.7998 232.02Z",
    fill: "#DAE4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0599 223.05L116.1 235.34L102.93 244.95L79.6899 231.11L93.0599 223.05Z",
    fill: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.1 320.53C194.944 320.53 197.25 318.224 197.25 315.38C197.25 312.536 194.944 310.23 192.1 310.23C189.256 310.23 186.95 312.536 186.95 315.38C186.95 318.224 189.256 320.53 192.1 320.53Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07 303.08C161.914 303.08 164.22 300.774 164.22 297.93C164.22 295.086 161.914 292.78 159.07 292.78C156.226 292.78 153.92 295.086 153.92 297.93C153.92 300.774 156.226 303.08 159.07 303.08Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07 319.79C161.914 319.79 164.22 317.484 164.22 314.64C164.22 311.796 161.914 309.49 159.07 309.49C156.226 309.49 153.92 311.796 153.92 314.64C153.92 317.484 156.226 319.79 159.07 319.79Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.11 303.89C195.954 303.89 198.26 301.584 198.26 298.74C198.26 295.896 195.954 293.59 193.11 293.59C190.266 293.59 187.96 295.896 187.96 298.74C187.96 301.584 190.266 303.89 193.11 303.89Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.29 306.88L184.37 302.35L192.67 298.55C195.67 297.18 195.63 292.91 192.61 291.59C191.64 291.17 190.53 291.17 189.56 291.59L175.95 297.53L163.17 290.22C160.28 288.57 156.81 291.15 157.57 294.39L157.74 295.14C157.99 296.19 158.67 297.09 159.62 297.62L166.77 301.55L158.83 305.02C155.78 306.35 155.78 310.68 158.83 312L159.54 312.31C160.53 312.74 161.66 312.73 162.65 312.28L175.57 306.38L188.58 313.53C191.47 315.12 194.87 312.54 194.12 309.33C193.88 308.3 193.22 307.41 192.3 306.89L192.29 306.88Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55 294.95C166.08 294.21 158.11 291.67 159.52 290.17C158.09 290.93 157.14 292.56 157.58 294.41L157.75 295.16C158 296.21 158.68 297.11 159.63 297.64L166.78 301.57L158.84 305.04C155.79 306.37 155.79 310.7 158.84 312.02L159.55 312.33C159.92 312.49 160.31 312.57 160.7 312.61C158.31 309.64 161.2 305.9 163.33 304.95C165.47 303.99 171.87 301.97 172.2 301.38C172.53 300.79 169.03 295.71 167.56 294.98L167.55 294.95Z",
    fill: "#4D5B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.48 270.12H181.25V300.23C181.25 302.09 179.74 303.6 177.88 303.6H173.85C171.99 303.6 170.48 302.09 170.48 300.23V270.12Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18 245.96L136.44 260.26C131.04 262.62 131.04 270.28 136.44 272.64L169.18 286.94C173.44 288.8 178.28 288.8 182.54 286.94L215.28 272.64C220.68 270.28 220.68 262.62 215.28 260.26L182.54 245.96C178.28 244.1 173.44 244.1 169.18 245.96Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55 286.93L215.29 272.63C217.51 271.66 218.8 269.79 219.2 267.77C218.15 268.87 216.69 270.38 215.82 271.21C214.35 272.61 191.82 281.88 189.46 283.21C187.1 284.54 179.89 286.52 177.02 285.79C174.15 285.05 173.72 284.43 171.57 282.77C169.42 281.11 155.15 274.89 148.6 272.76C142.14 270.66 134.2 266.62 134.54 261.52C131.17 264.64 131.8 270.61 136.46 272.64L169.2 286.94C173.46 288.8 178.3 288.8 182.56 286.94L182.55 286.93Z",
    fill: "#4D5B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79 213.91L203.47 200.76C211.32 197.16 220.27 202.9 220.27 211.54V237.92C220.27 242.56 217.57 246.77 213.35 248.7L184.67 261.85C176.82 265.45 167.87 259.71 167.87 251.07V224.69C167.87 220.05 170.57 215.84 174.79 213.91Z",
    fill: "#586475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.51 282.08H196.48C194.62 282.08 193.11 280.57 193.11 278.71V229.6C193.11 228.38 193.85 227.27 194.97 226.8L199.69 224.83C201.69 224 203.88 225.46 203.88 227.63V278.7C203.88 280.56 202.37 282.07 200.51 282.07V282.08Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.11 237.05C193.11 237.05 191.88 257.15 188.64 258.69C185.4 260.24 176.93 260.31 175.39 257.05C173.84 253.79 173.62 239.32 173.71 236.53C173.8 233.73 168.84 222.69 172.69 215.15C169.7 217.36 167.87 220.88 167.87 224.69V251.07C167.87 259.71 176.81 265.45 184.67 261.85L194.68 257.26L194.9 257.06L193.11 237.05Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.36 314.63L206.35 291.48V368.11L259.36 391.25V314.63Z",
    fill: "#B57D2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.04 271.09L306.03 247.94V324.57L359.04 347.71V271.09Z",
    fill: "#B57D2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.41 246.04L206.35 291.48L259.28 314.54L363.34 269.1L310.41 246.04Z",
    fill: "#FCCF97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.36 314.51L263.66 312.64V389.39L259.36 391.25V314.51Z",
    fill: "#D8A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.04 270.97L363.34 269.1V345.85L359.04 347.71V270.97Z",
    fill: "#D8A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.36 314.51L363.34 269.1V275.2L259.36 321.08V314.51Z",
    fill: "#D8A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.95 262.69L246.86 276.7L263.18 283.81L295.27 269.8L278.95 262.69Z",
    fill: "#BFC9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 273.8L248.39 277.37L246.86 276.7L264.77 268.88L272 273.8Z",
    fill: "#A3B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77 255.53H274.93V270.29C274.93 272.26 273.33 273.86 271.36 273.86H268.35C266.38 273.86 264.78 272.26 264.78 270.29V255.53H264.77Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.58 226.36L293.73 199.22C295.22 198.57 296.91 199.53 297.12 201.14L302.97 245.41C303.11 246.49 302.52 247.53 301.53 247.97L239.38 275.11C237.89 275.76 236.2 274.8 235.99 273.19L230.14 228.92C230 227.84 230.59 226.8 231.58 226.36Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.04 229.81L294.56 203.38L300 244.51L239.47 270.94L234.04 229.81Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92 269.86L268.19 285.02L285.85 292.72L320.58 277.56L302.92 269.86Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.19 285.02V286.65L285.86 294.3V292.72L268.19 285.02Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.86 294.3L320.58 279.2V277.56L285.86 292.72V294.3Z",
    fill: "#BFC9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.03 259.97L307.96 270.08L324.78 277.4L347.85 267.3L331.03 259.97Z",
    fill: "#DAE4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.811 267.6C320.811 267.6 324.941 270.98 327.001 272.26C329.061 273.54 333.501 273.09 334.161 270.99C334.821 268.89 331.921 265.81 329.201 265.24C326.481 264.67 323.491 265.02 323.491 265.02L320.811 266.29V267.61V267.6Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 272.26C328 272.88 329.55 273.09 330.97 272.91C329.26 272.82 328.55 270.85 328.22 269.54C327.89 268.23 325.43 266.98 324.36 266.86C323.29 266.74 321.28 266.36 320.8 266.28V267.6C320.8 267.6 324.93 270.98 326.99 272.26H327Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.35 291.66L266.06 300.56C266.79 301.03 266.7 302.13 265.9 302.48L257.51 306.16C257.15 306.32 256.74 306.27 256.43 306.04L243.2 296.42C242.5 295.91 242.64 294.82 243.46 294.51L251.37 291.55C251.69 291.43 252.06 291.47 252.35 291.66Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.81 294.82L257.08 304.58L265.47 300.84L251.72 291.82L243.81 294.82Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.63 391.18C354.474 391.18 356.78 388.874 356.78 386.03C356.78 383.186 354.474 380.88 351.63 380.88C348.786 380.88 346.48 383.186 346.48 386.03C346.48 388.874 348.786 391.18 351.63 391.18Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59 373.74C321.434 373.74 323.74 371.434 323.74 368.59C323.74 365.746 321.434 363.44 318.59 363.44C315.746 363.44 313.44 365.746 313.44 368.59C313.44 371.434 315.746 373.74 318.59 373.74Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59 390.45C321.434 390.45 323.74 388.144 323.74 385.3C323.74 382.456 321.434 380.15 318.59 380.15C315.746 380.15 313.44 382.456 313.44 385.3C313.44 388.144 315.746 390.45 318.59 390.45Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63 374.55C355.474 374.55 357.78 372.244 357.78 369.4C357.78 366.556 355.474 364.25 352.63 364.25C349.786 364.25 347.48 366.556 347.48 369.4C347.48 372.244 349.786 374.55 352.63 374.55Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.82 377.53L343.9 373L352.2 369.2C355.2 367.83 355.16 363.56 352.14 362.24C351.17 361.82 350.06 361.82 349.09 362.24L335.48 368.18L322.7 360.87C319.81 359.22 316.34 361.8 317.1 365.04L317.27 365.79C317.52 366.84 318.2 367.74 319.15 368.27L326.3 372.2L318.36 375.67C315.31 377 315.31 381.33 318.36 382.65L319.07 382.96C320.06 383.39 321.19 383.38 322.18 382.93L335.1 377.03L348.11 384.18C351 385.77 354.4 383.19 353.65 379.98C353.41 378.95 352.75 378.06 351.83 377.54L351.82 377.53Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.07 365.6C325.6 364.86 317.63 362.32 319.04 360.82C317.61 361.58 316.66 363.21 317.1 365.06L317.27 365.81C317.52 366.86 318.2 367.76 319.15 368.29L326.3 372.22L318.36 375.69C315.31 377.02 315.31 381.35 318.36 382.67L319.07 382.98C319.44 383.14 319.83 383.22 320.22 383.26C317.83 380.29 320.72 376.55 322.85 375.6C324.99 374.64 331.39 372.62 331.72 372.03C332.05 371.44 328.55 366.36 327.08 365.63L327.07 365.6Z",
    fill: "#4D5B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 340.77H340.77V370.88C340.77 372.74 339.26 374.25 337.4 374.25H333.37C331.51 374.25 330 372.74 330 370.88V340.77Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71 316.61L295.97 330.91C290.57 333.27 290.57 340.93 295.97 343.29L328.71 357.59C332.97 359.45 337.81 359.45 342.07 357.59L374.81 343.29C380.21 340.93 380.21 333.27 374.81 330.91L342.07 316.61C337.81 314.75 332.97 314.75 328.71 316.61Z",
    fill: "#6A7484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.07 357.58L374.81 343.28C377.03 342.31 378.32 340.44 378.72 338.42C377.67 339.52 376.21 341.03 375.34 341.86C373.87 343.26 351.34 352.53 348.98 353.86C346.62 355.19 339.41 357.17 336.54 356.44C333.67 355.7 333.24 355.08 331.09 353.42C328.94 351.76 314.67 345.54 308.12 343.41C301.66 341.31 293.72 337.27 294.06 332.17C290.69 335.29 291.32 341.26 295.98 343.29L328.72 357.59C332.98 359.45 337.82 359.45 342.08 357.59L342.07 357.58Z",
    fill: "#4D5B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.31 284.56L362.99 271.41C370.84 267.81 379.79 273.55 379.79 282.19V308.57C379.79 313.21 377.09 317.42 372.87 319.35L344.19 332.5C336.34 336.1 327.39 330.36 327.39 321.72V295.34C327.39 290.7 330.09 286.49 334.31 284.56Z",
    fill: "#586475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.04 352.73H356.01C354.15 352.73 352.64 351.22 352.64 349.36V300.25C352.64 299.03 353.38 297.92 354.5 297.45L359.22 295.48C361.22 294.65 363.41 296.11 363.41 298.28V349.35C363.41 351.21 361.9 352.72 360.04 352.72V352.73Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63 307.7C352.63 307.7 351.4 327.8 348.16 329.34C344.92 330.89 336.45 330.96 334.91 327.7C333.36 324.44 333.14 309.97 333.23 307.18C333.32 304.38 328.36 293.34 332.21 285.8C329.22 288.01 327.39 291.53 327.39 295.34V321.72C327.39 330.36 336.33 336.1 344.19 332.5L354.2 327.91L354.42 327.71L352.63 307.7Z",
    fill: "#3F516B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16 89.16L178.59 146.99L219.35 134.33L218.35 77.76L178.16 89.16Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.46 85.6999L176.09 97.7899L171.95 94.9199L180.58 83.6299L183.46 85.6999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M220.72 128.47L213.06 138.38L215.83 139.64L223.1 130.85L220.72 128.47Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1607_4998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 553.99,
    height: 449.08,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.0fbe81f6a9c638ff2899a37670d4cc5d.svg";
export { ForwardRef as ReactComponent };